import React from 'react';
import styles from './ExploreByStyle.module.scss';
import ExploreByStyleRow from './ExploreByStyleRow';
import { EXPLORE_BY_STYLE, EXPLORE_BY_ROOM } from './ExploreByStyle.data';

export default function ExploreByStyle() {
  return (
    <section className={styles.Section} data-test="explore-by-style">
      <div className={styles.Container}>
        <ExploreByStyleRow
          title="Explore By Style"
          tiles={EXPLORE_BY_STYLE}
          trackingRow="style"
        />
        <ExploreByStyleRow
          title="Explore By Room"
          tiles={EXPLORE_BY_ROOM}
          trackingRow="room"
        />
      </div>
    </section>
  );
}
